// Recuperar contraseña: textos y ayudas compartidos por /recuperar y la
// tarjeta «Ya tienes cuenta» del link público de inscripción.

/** Qué hacer si el correo de recuperación no llega (Alex Zayat 2026-10-03:
 * jugadores en el club decían que nunca les llegaba). Español claro, corto.
 * El tip del PIN cubre también al jugador inscrito CON correo pero que aún
 * no tiene cuenta (nunca recibió bienvenida ni PIN): para él el servidor no
 * manda nada y solo su organizador lo destraba. */
export const RESET_EMAIL_TIPS: readonly string[] = [
  "Revisa spam o promociones.",
  "Usa el correo con el que te inscribiste (si te inscribió tu papá o mamá, es el de ellos).",
  "Si nunca te llegó un mensaje de bienvenida ni un PIN, o tu club te dio de alta sin correo, pídele tu PIN de acceso a tu organizador.",
  "Si lo pides otra vez, usa solo el correo más reciente: el enlace anterior deja de servir.",
];

/** Igual que `_mask_email` del servidor: 'eduardozaga21@gmail.com' →
 * 'e•••••1@gmail.com'. Sirve para saber si el correo escrito es el de la
 * cuenta sin que el servidor lo revele completo. */
export function maskEmailLikeServer(value: string): string {
  const at = value.indexOf("@");
  if (at < 0) return "•••";
  const local = Array.from(value.slice(0, at));
  const domain = value.slice(at + 1);
  if (!domain) return "•••";
  if (local.length <= 2) return `${local[0] ?? ""}•@${domain}`;
  return `${local[0]}${"•".repeat(Math.min(5, local.length - 2))}${local[local.length - 1]}@${domain}`;
}

/** ¿El correo escrito es (casi seguro) el de la cuenta? Si la máscara no
 * coincide, la cuenta usa OTRO correo y pedir el enlace con el escrito no
 * mandaría nada. Sin máscara no hay con qué comparar: no lo contradice. */
export function emailMatchesMasked(typedEmail: string, maskedEmail: string | null | undefined): boolean {
  if (!maskedEmail) return true;
  const typed = typedEmail.trim().toLowerCase();
  if (!typed) return false;
  return maskEmailLikeServer(typed) === maskedEmail;
}
